import { render, staticRenderFns } from "./SitePermission.vue?vue&type=template&id=630e17ea&"
import script from "./SitePermission.vue?vue&type=script&lang=js&"
export * from "./SitePermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports